import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";

import { Grid } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

import font from "src/styles/font";
import { Black } from "src/styles/color";

import Dialog from "src/components/core/Dialog";
import TextField from "src/components/core/TextField";
import CustomMap from "src/components/ui/Maps/CustomMaps";

import { SpanLabel } from "src/modules/order/shipping-order/components";
import {
  MapsContainer,
  WrapperMapsContainer,
} from "src/components/order/components";

const StyledDialog = muiStyled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 16,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    padding: 24,
    paddingTop: 0,
  },
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: 640,
    },
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
  "& .MuiDialogActions-root>:not(:first-of-type)": {
    marginLeft: 24,
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiPaper-root": {
      margin: 24,
    },
    "& .MuiDialogContent-root": {
      padding: 16,
      paddingTop: 0,
    },
    "& .MuiDialogActions-root": {
      padding: 16,
    },
  },
}));

const CloseButton = styled(IconButton)`
  &.MuiIconButton-root {
    color: ${Black};
  }
`;

const LocationDialog = ({ onClose, info }) => {
  return (
    <StyledDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <DialogTitle
        sx={{
          p: {
            sm: 3,
            xs: 2,
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          fontSize: {
            sm: font.size.lg,
            xs: font.size.md,
          },
          fontWeight: 600,
        }}
      >
        หมุดร้านค้า
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>
      </DialogTitle>

      <DialogContent>
        <WrapperMapsContainer>
          <MapsContainer>
            <CustomMap
              markerLocation={{
                lat: info?.fulfillmentProcess[0]?.pickupAddress?.coordinates
                  ?.lat,
                lng: info?.fulfillmentProcess[0]?.pickupAddress?.coordinates
                  ?.lng,
              }}
              doNotCustom
              //   inputPlaceholder="ตำแหน่งที่ตั้งร้านค้า"
            />
          </MapsContainer>
        </WrapperMapsContainer>

        <Grid container xs={12} mt={2}>
          <SpanLabel isMargin>ที่อยู่ร้านค้า</SpanLabel>
          <TextField
            variant="outlined"
            fullWidth
            value={info?.fulfillmentProcess[0]?.pickupAddress?.address}
            disabled
          />
        </Grid>
      </DialogContent>
    </StyledDialog>
  );
};

export default LocationDialog;
